// Global
import React, { useEffect, useState } from 'react';
import { RichTextField, Text, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';

interface PageTitleProps {
  fields: {
    data: {
      item: {
        id: string;
        name: string;
        PageTitle: { value: string };
        PageTitleCallout?: { value: string };
      };
    };
  };
}

const PageTitle = (props: PageTitleProps): JSX.Element => {
  const { fields } = props;
  const [hasBreadcrumbs, setHasBreadcrumbs] = useState(false);
  const sitecoreContext = useSitecoreContext();
  useEffect(() => {
    const breadcrumbs = document.querySelector('[aria-label="breadcrumbs"]');
    setHasBreadcrumbs(!!breadcrumbs);
  }, []);
  if (!fields) {
    return <></>;
  }
  const PageTitle = sitecoreContext?.sitecoreContext?.route?.fields?.PageTitle;
  const PageTitleCallout = sitecoreContext?.sitecoreContext?.route?.fields?.PageTitleCallout;
  return (
    <section
      className={classNames('container', {
        '': !hasBreadcrumbs,
      })}
      aria-label="page-title"
    >
      <Text
        field={PageTitleCallout as TextField}
        editable={true}
        tag="div"
        className="mt-4 md:mt-6 mb-2 bg-light-background-secondary-brand text-light-fill-inverse text-caption-lg flex items-center h-7 w-max relative px-3 after:content-[''] after:border-b-[28px] after:border-solid after:border-b-light-stroke-secondary-brand after:border-r-[28px] after:border-r-transparent after:absolute after:-right-[28px]"
      />
      <RichTextA11yWrapper
        field={PageTitle as RichTextField}
        editable={true}
        tag="h1"
        className="flex flex-col after:block after:w-12 after:h-1 after:bg-light-stroke-secondary-brand after:mt-2 after:mb-4 after:lg:mb-8"
      />
    </section>
  );
};

export default PageTitle;
